import React from "react";
import { Row, Col, Typography, Space } from "antd";
import "./JoinWorkToPDF.css";
import LogoForPDF from "../../../svg/svgicon/LogoForPDF";
const { Text } = Typography;
const Str = require('@supercharge/strings');
class JoinWorkToPDF extends React.Component {
  state = {
    data: this.props.data,
    text: [],
    dkey: 1,
  };
  componentDidMount = () => {
    this.getData();
  };
  getData = () => {
    this.setState({data: this.props.data});
    this.setState({text: Str(this.props.data.note).lines() });
  };
  render() {
    return (
      <div style={{ padding: 10 }} key={this.state.dkey}>
        <Row justify="center" align="middle">
          <Col style={{ marginTop: -20, marginRight: 20 }}>
            <LogoForPDF />
          </Col>
          <Col>
            <div className="PDFHeaderLabel">MONGOLYN ALT (MAK)</div>
          </Col>
        </Row>
        <Row style={{ marginTop: -10 }} justify="center">
          <div className="PDFSubHeaderLabel">CORPORATION</div>
        </Row>
        <Row style={{ marginTop: 20 }} justify="center">
          <div className="PDFTitleLabel">{this.state.data.joinworkname}</div>
        </Row>
        <Row style={{ marginTop: 20 }}>
          <Space direction="vertical">
            {this.state.text.map(value => 
              <Text>{value}</Text>
            )
            }
          </Space>
        </Row>
        <Row style={{ marginTop: 20 }} justify="start">
          <div className="PDFContentLabel">
            <text style={{fontWeight: 500}}>Хамтран ажиллах саналын материалыг</text> {this.state.data.enddate} хүртэл  хүлээн авна.
          </div>
        </Row>
      </div>
    );
  }
}

export default JoinWorkToPDF;
